import { ComponentProps } from 'react';

import Form from '../../../Form/Form';
import CouponCodeFormFields from '../CouponCodeFormFields/CouponCodeFormFields';

type ApplyCouponDialogProps = {
    url: string;
    onSuccess?: (code: string | undefined) => void;
} & ComponentProps<typeof CouponCodeFormFields>;

type Response = {
    code: string;
};

const ApplyCouponDialog = ({
    url,
    onSuccess,
    ...fieldsProps
}: ApplyCouponDialogProps) => {
    return (
        <Form<Response>
            action={url}
            method="post"
            onSuccess={(data) => onSuccess && onSuccess(data.code)}
        >
            <CouponCodeFormFields {...fieldsProps} />
        </Form>
    );
};

export default ApplyCouponDialog;
